import { render, staticRenderFns } from "./PlanMobile.vue?vue&type=template&id=c65901fc&scoped=true"
import script from "./PlanMobile.vue?vue&type=script&lang=js"
export * from "./PlanMobile.vue?vue&type=script&lang=js"
import style0 from "./PlanMobile.vue?vue&type=style&index=0&id=c65901fc&prod&lang=scss&scoped=true"
import style1 from "./PlanMobile.vue?vue&type=style&index=1&id=c65901fc&prod&lang=css"
import style2 from "./PlanMobile.vue?vue&type=style&index=2&id=c65901fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65901fc",
  null
  
)

export default component.exports